export const ChartColours = [
    '#1BA5F5',
    '#59CD90',
    '#ffc658',
    '#b078c1',
    '#ff604f',
    '#ff9a56',
    '#8dd1e1',
    '#79c6d8',
    '#bcf60c',
    '#fabebe',
    '#008080',
    '#e6beff',
    '#9a6324',
    '#fffac8',
    '#800000',
    '#aaffc3',
    '#808000',
    '#ffd8b1',
    '#000075',
    '#808080',
    '#ffffff'
];
